import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {

	return {
		topHeader: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "left",
			borderBottom   : theme.other.darkMode ? "none" : `solid 2px ${ theme.other.colors.border.primary }`,
			padding        : "1.25rem 2rem",
			zIndex         : "1202",
			top            : "0",
			position       : "sticky",
			background     : theme.other.colors.background.tertiary
		},
		settingsText: {
			fontWeight : "500",
			fontSize   : "2rem"
		},
		editImageOptionsText: {
			marginLeft: "1rem !important"
			// fontWeight : "500",
			// fontSize   : "1.5rem"
		},
		settingsHeader: {
			marginLeft : "2rem !important",
			fontSize   : "1.3rem",
			color      : "#126bd5"
		},
		crossIcon: {
			position : "absolute",
			right    : "10px",
			cursor   : "pointer",
			height   : "3rem",
			width    : "3rem"
		},
		inputLabelandContentWrapper: {
			display       : "flex",
			flexDirection : "column",
			marginBottom  : "20px"
		},
		inputWrapper: {
			width: "100%"
		},
		iconLabel: {
			display      : "flex",
			alignItems   : "center",
			marginBottom : "0.75rem",

			"& .label": {
				fontSize   : "1.4rem",
				fontWeight : "500"
			}
		},
		inputContent: {
			margin          : 0,
			padding         : "1.25rem",
			border          : "none",
			outline         : "none",
			userSelect      : "none",
			width           : "100%",
			borderRadius    : "1rem",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : "rgba(0, 0, 0, 0.1)",
			color           : theme.other.colors.text.primary,
			caretColor      : theme.other.paletteNew.primaryDarkBlue,
			"&:focus"       : {
				outline: `solid 1px ${ theme.other.paletteNew.primaryDarkBlue }`
			},

			"&.error": {
				border: "solid 1px red !important"
			},
			"&::placeholder": {
				color      : "#757575",
				fontSize   : "1.3rem",
				fontWeight : "normal"
			}
		},
		inputContentSettings: {
			margin          : 0,
			padding         : "10px",
			backgroundColor : "#fff",
			border          : "1px solid #e7e7e7",
			outline         : "none",
			userSelect      : "none",
			width           : "100%",
			borderRadius    : "5px",
			color           : "#000000",
			caretColor      : "#126bd5",
			"&:focus"       : {
				border: "solid 1px #126bd5"
			},

			"&.error": {
				border: "solid 1px red !important"
			},
			"&::placeholder": {
				color      : "#757575",
				fontSize   : "1.3rem",
				fontWeight : "normal"
			}
		},
		followingGameChip: {
			background    : theme.other.colors.background.tertiary,
			color         : theme.other.colors.text.primary,
			borderRadius  : "10px",
			fontSize      : "1.3rem",
			border        : `1px solid ${ theme.other.colors.border.primary }`,
			padding       : "0.6rem",
			textTransform : "none",
			margin        : "0.2rem 0.5rem",

			"&:hover": {
				background : theme.other.colors.background.tertiary,
				border     : `1px solid ${ theme.other.colors.border.primary }`
			}
		},
		followingGamesContainer: {
			outline         : props?.gamesSelectedActive ? `2px solid ${ theme.other.paletteNew.primaryDarkBlue }` : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`,
			borderRadius    : "10px",
			padding         : props?.userProfileDetails?.followingGames?.length === 0 ? "2rem 1.25rem" : "1rem 1.25rem",
			cursor          : "pointer",
			display         : "flex",
			alignItems      : "center",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : "rgba(0, 0, 0, 0.1)",
			justifyContent  : "space-between"

		},
		contentlocaleContainer: {
			outline         : props?.languagesSelectedActive ? `2px solid ${ theme.other.paletteNew.primaryDarkBlue }` : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`,
			borderRadius    : "10px",
			padding         : !( props?.userProfileDetails?.contentLocale ) ? "2rem 1.25rem" : "1rem 1.25rem",
			cursor          : "pointer",
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "space-between",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : "rgba(0, 0, 0, 0.1)"
		},
		errorUrl: {
			marginTop : "5px",
			color     : "red",
			fontSize  : "13px"
		},
		mobileNumber: {
			margin          : 0,
			display         : "flex",
			padding         : "10px",
			fontSize        : "1.3rem",
			border          : "none",
			outline         : "none",
			userSelect      : "none",
			width           : "100%",
			borderRadius    : "1rem",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : "rgba(0, 0, 0, 0.1)",
			color           : theme.other.colors.text.primary,
			caretColor      : theme.other.paletteNew.primaryDarkBlue
		},
		labelInput: {
			fontSize     : "1.4rem",
			fontWeight   : "500",
			marginBottom : "0.75rem"

		},
		labelInputTag: {
			display      : "flex",
			alignItems   : "center",
			width        : "135px",
			fontSize     : "1.4rem",
			fontWeight   : "500",
			marginBottom : "2.5rem"
		},
		labelInputTagSubHeading: {
			display      : "flex",
			alignItems   : "center",
			width        : "135px",
			fontSize     : "1.4rem",
			fontWeight   : "500",
			margin       : "1rem 0",
			marginBottom : "0.75rem"
		},
		verifiedMobileTick: {
			marginLeft : "5px",
			height     : "1.75rem",
			width      : "1.75rem"
		},
		handleIcon: {
			height      : "1.75rem",
			width       : "1.75rem",
			marginRight : "0.8rem"
		},
		button: {
			border    : "1px solid #ffffff",
			"&:hover" : {
				border     : "1px solid #fefefe",
				background : "rgb(0 0 0 / 80%)"
			},
			background: "rgb(0 0 0 / 50%)"
		},
		customDialog: {
			maxHeight       : "calc(100% - 40px)",
			borderRadius    : "15px",
			backgroundColor : theme.other.colors.dialog.primary
		},
		downArrowIcon: {
			// transform   : "scale(0.8)",
			height : "1.5rem",
			width  : "1.5rem"
			// marginRight : "1rem"
		},
		textAreaInput: {
			padding         : "1rem",
			border          : "none",
			outline         : "none",
			userSelect      : "none",
			width           : "100%",
			minHeight       : "10rem",
			borderRadius    : "5px",
			resize          : "none",
			fontFamily      : "inherit",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : "rgba(0, 0, 0, 0.1)",
			color           : theme.other.colors.text.primary,
			caretColor      : theme.other.paletteNew.primaryDarkBlue,
			"&:focus"       : {
				border: "solid 1px #126bd5"
			},
			"&::placeholder": {
				color      : "#757575",
				fontSize   : "1.3rem",
				fontWeight : "normal"
			}
		},
		userAvatar: {
			display        : "flex",
			flexDirection  : "column",
			justifyContent : "center",
			alignItems     : "center",
			marginBottom   : "2.5rem",
			marginTop      : "1rem"
		},
		photo: {
			height       : "100%",
			borderRadius : "50%",
			position     : "absolute"
		},
		genderDropdown: {
			width    : "100%",
			fontSize : "14px",
			// fontWeight : "500",
			color    : theme.other.colors.text.primary

		},
		separator: {
			background   : theme.other.colors.border.primary,
			height       : "1px",
			marginTop    : "25px",
			marginBottom : "22px"
		},
		heading: {
			fontSize     : "13px",
			fontWeight   : "500",
			background   : "white",
			paddingLeft  : "10px",
			paddingRight : "10px",
			position     : "absolute",
			top          : "-8px"
		},
		saveBtn: {
			fontWeight: "500"
		},
		saveButton: {
			height        : "30px",
			background    : theme.other.paletteNew.mainGradient,
			textTransform : "none !important",
			boxShadow     : "none !important",
			borderRadius  : "10px",
			padding       : "1.7rem 1.5rem"
		},
		avatarContainer: {
			margin  : "0 0.8rem 1.5rem 0.8rem",
			display : "flex"
			// position : "relative"
			// maxHeight : "7rem"
		},
		actorAvatar: {
			width     : "80px",
			height    : "80px",
			objectFit : "contain",
			border    : "0.5px solid black",
			// position  : "relative",
			...theme.other.rooterAvatars.borderRadius
		},
		saveButtonContainer: {
			background : theme.other.colors.background.tertiary,
			position   : "sticky",
			bottom     : "0",
			padding    : "1.75rem",
			textAlign  : "end"
		},
		mainContent: {
			// width           : "590px",
			minWidth        : "40w",
			overflow        : "hidden",
			padding         : "10px 24px",
			backgroundColor : theme.other.colors.dialog.secondary
		},
		inputContainer: {
			marginBottom: "2rem"
		},
		modalContent: {
			flex: "0 0 auto"
			// zIndex : "99999"
		},
		modalBody: {
			padding: "0"
		},
		editPhoto: {
			padding       : "1rem 2rem",
			height        : "unset",
			textTransform : "uppercase",
			color         : theme.other.colors.textBtn.default.text
		}
	};
} );
